import React, { Component } from "react";

export class Step4Duration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      internshipDuration: props.formData.internshipDuration || "",
      internshipMode: props.formData.internshipMode || "",
      preferredBatch: props.formData.preferredBatch || "",
      joiningDate: props.formData.joiningDate || "",
      error: "",
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: "",
    });
  };

  handleNext = () => {
    const {
      internshipDuration,
      internshipMode,
      preferredBatch,
      joiningDate,
    } = this.state;

    if (
      !internshipDuration ||
      !internshipMode ||
      !preferredBatch ||
      !joiningDate
    ) {
      this.setState({
        error: "Please fill all required fields.",
      });
      return;
    }

    this.props.updateFormData({
      internshipDuration,
      internshipMode,
      preferredBatch,
      joiningDate,
    });

    this.props.nextStep();
  };

  render() {
    return (
      <div className="container py-4">

        <div className="card shadow border-0">

          <div className="card-header bg-success text-white">
            <h3 className="mb-0">
              Step 4 : Internship Duration
            </h3>
          </div>

          <div className="card-body">

            <div className="row">

              {/* Duration */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Internship Duration *
                </label>

                <select
                  className="form-select"
                  name="internshipDuration"
                  value={this.state.internshipDuration}
                  onChange={this.handleChange}
                >
                  <option value="">Select Duration</option>
                  <option>15 Days</option>
                  <option>1 Month</option>
                  <option>2 Months</option>
                  <option>3 Months</option>
                  <option>6 Months</option>
                </select>
              </div>

              {/* Mode */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Internship Mode *
                </label>

                <select
                  className="form-select"
                  name="internshipMode"
                  value={this.state.internshipMode}
                  onChange={this.handleChange}
                >
                  <option value="">Select Mode</option>
                  <option>Offline</option>
                  <option>Online</option>
                  <option>Hybrid</option>
                </select>
              </div>

              {/* Batch */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Preferred Batch *
                </label>

                <select
                  className="form-select"
                  name="preferredBatch"
                  value={this.state.preferredBatch}
                  onChange={this.handleChange}
                >
                  <option value="">Select Batch</option>
                  <option>Morning (9 AM - 11 AM)</option>
                  <option>Afternoon (11 AM - 2 PM)</option>
                  <option>Evening (2 PM - 5 PM)</option>
                  <option>Flexible</option>
                </select>
              </div>

              {/* Joining Date */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Preferred Joining Date *
                </label>

                <input
                  type="date"
                  className="form-control"
                  name="joiningDate"
                  value={this.state.joiningDate}
                  onChange={this.handleChange}
                />
              </div>

            </div>

            <div className="alert alert-info mt-3">
              <strong>Note:</strong> Batch availability depends on current internship slots.
            </div>

            {this.state.error && (
              <div className="alert alert-danger">
                {this.state.error}
              </div>
            )}

            <hr />

            <div className="d-flex justify-content-between">

              <button
                className="btn btn-outline-secondary"
                onClick={this.props.prevStep}
              >
                Previous
              </button>

              <button
                className="btn btn-success"
                onClick={this.handleNext}
              >
                Next
              </button>

            </div>

          </div>

        </div>

      </div>
    );
  }
}

export default Step4Duration;